import { GET_SECOND_PARENT_STATUSES } from "../../../enums/Request/request.types";

export const getSecondParentStatusesAction = (data) =>  {
    return {
        type: GET_SECOND_PARENT_STATUSES,
        payload: data,
    }
}
